import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

import { colors } from '../../styles/colors';

const SpinnerAnim = styled.svg`
  display: block;
  margin: 4rem auto;
  animation: loading 1s ease-out infinite;
  @keyframes loading {
    25% {
      opacity: 0.6;
      transform: rotate(-40deg);
    }
    50% {
      opacity: 0.8;
      transform: rotate(0deg);
    }
    75% {
      opacity: 0.6;
      transform: rotate(40deg);
    }
    100% {
      opacity: 1;
      transform: rotate(0deg);
    }
  }
`;

const Spinner = () => {
  return (
    <SpinnerAnim
      width="50px"
      height="50px"
      viewBox="0 0 32 32"
      // tslint:disable-next-line:no-http-string
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M26.14 12.8675C22.4095 14.9456 19.1173 17.7161 16.4383 21.0058C16.3053 21.1665 16.1072 21.2712 15.8822 21.2712C15.6876 21.2712 15.5092 21.1969 15.3793 21.072C13.4903 19.4034 11.4117 17.9446 9.18005 16.732C8.95966 16.6081 8.81155 16.37 8.81155 16.0991C8.81155 15.9323 8.86513 15.7771 8.95915 15.6548C9.67592 14.751 10.4286 13.877 11.2146 13.0349C11.3465 12.8938 11.5346 12.8059 11.7433 12.8059C11.8682 12.8059 11.9885 12.8357 12.0911 12.8918C13.1289 13.4812 14.1363 14.1181 15.1109 14.7995C15.1801 14.8546 15.2671 14.8884 15.3626 14.8925C15.4824 14.8971 15.5941 14.8541 15.6755 14.7788C18.9025 11.6246 22.7037 9.03446 26.8815 7.17431C27.1802 7.0439 27.5098 6.9716 27.8561 6.9716C28.772 6.9716 29.5696 7.4771 29.9862 8.22419H29.9867C31.2691 10.5262 32 13.1779 32 16C32 24.8368 24.8368 32 16 32C7.16317 32 0 24.8368 0 16C0 7.16369 7.16317 0 16 0C19.1603 0 22.1062 0.916448 24.5871 2.49758L24.5881 2.49455C24.7352 2.58302 24.8338 2.74377 24.8338 2.92775C24.8338 3.12946 24.716 3.30282 24.5452 3.3842C23.1738 4.01656 21.8418 4.72069 20.5534 5.49054L20.5524 5.48903C20.4396 5.56131 20.3057 5.60327 20.1621 5.60327C20.062 5.60327 19.967 5.58305 19.8801 5.54666H19.876C18.6689 5.09879 17.3633 4.85415 16 4.85415C9.84425 4.85415 4.85414 9.84425 4.85414 16C4.85414 22.1558 9.84425 27.1459 16 27.1459C22.1558 27.1459 27.1459 22.1558 27.1459 16C27.1459 15.0052 27.0154 14.0403 26.7708 13.1223H26.7703C26.7197 12.9484 26.5625 12.8185 26.3715 12.8109C26.2871 12.8074 26.2077 12.8281 26.14 12.867V12.8675Z" fill="#32BA55"></path>
    </SpinnerAnim>
  );
};

export default Spinner;
